<div class="UsersMainContent animated fadeIn" *ngIf="!this.parent.loading">

  <!-- Page Header -->
  <div class="PageHeader">
    <div class="PageTitle">
      <i class="material-icons">people</i>
      <span>{{ 'UsersMenu.Title' | translate }}</span>
    </div>
    <div class="SearchContainer">
      <i class="material-icons search-icon">search</i>
      <input class="SearchInput" type="text" [placeholder]="'SearchUser' | translate"
             [(ngModel)]="this.searchTerm" (change)="GetUsersFiltered();" autocomplete="off">
      <i class="material-icons clear-icon" *ngIf="this.searchTerm" (click)="this.searchTerm=''; GetUsersFiltered();">close</i>
    </div>
  </div>

  <!-- Users Grid -->
  <div class="GridContainer">
    <!-- Grid Header -->
    <div class="GridHeader">
      <div class="GridCell col-user">{{ 'Login.User' | translate }}</div>
      <div class="GridCell col-email">{{ 'Login.Email' | translate }}</div>
      <div class="GridCell col-registered">{{ 'AccountSettingsPage.Registered' | translate }}</div>
      <div class="GridCell col-expand"></div>
    </div>

    <!-- Grid Body -->
    <div class="GridBody">
      <ng-container *ngFor="let user of users">
        <!-- User Row -->
        <div class="GridRow" (click)="toggleUserPanel(user);">
          <div class="GridCell col-user">{{user.UserName}}</div>
          <div class="GridCell col-email">{{user.Email}}</div>
          <div class="GridCell col-registered">{{user.EventRegisterUI}}</div>
          <div class="GridCell col-expand">
            <i class="material-icons">chevron_right</i>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

</div>

<!-- User Detail Popup (ModernPopup) -->
<div class="ModernPopupOverlay" *ngIf="ShowUserDetailPopup" (click)="CloseUserDetailPopup()">
  <div class="ModernPopup medium" (click)="$event.stopPropagation()">
    <!-- Popup Header -->
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">person</i>
        <span>{{selectedUserForPopup?.UserName}}</span>
      </div>
      <button class="ModernPopupClose" (click)="CloseUserDetailPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Popup Body -->
    <div class="ModernPopupBody" *ngIf="selectedUserForPopup">

      <!-- Loading state -->
      <div class="LoadingState" *ngIf="loadingUser">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>

      <div class="UserDetailInner" *ngIf="!loadingUser">

        <!-- Main Role Dropdown -->
        <div class="FormGroup">
          <label class="FormLabel">{{ 'AccountSettingsPage.MainRole' | translate }}</label>
          <div class="CustomDropdown">
            <div class="DropdownTrigger" [class.open]="showMainRoleDropdown" (click)="showMainRoleDropdown = !showMainRoleDropdown;">
              <span>{{selectedUserForPopup.Rights?.MainRole?.Meaning || '—'}}</span>
              <i class="material-icons arrow-icon">expand_more</i>
            </div>
            <div class="DropdownResults" *ngIf="showMainRoleDropdown">
              <div class="DropdownItem" *ngFor="let role of this.parent.masterData.Roles"
                   [class.selected]="selectedUserForPopup.Rights?.MainRole?.ID === role.ID"
                   (click)="selectMainRole(role, selectedUserForPopup);">
                <span>{{role.Meaning}}</span>
                <i class="material-icons check-icon" *ngIf="selectedUserForPopup.Rights?.MainRole?.ID === role.ID">check</i>
              </div>
            </div>
          </div>
        </div>

        <!-- Page Access (URL Access) Dropdown -->
        <div class="FormGroup">
          <label class="FormLabel">{{ 'AccountSettingsPage.PageAccess' | translate }}</label>
          <div class="CustomDropdown">
            <div class="DropdownTrigger" [class.open]="showUrlAccessDropdown" (click)="showUrlAccessDropdown = !showUrlAccessDropdown;">
              <span>{{selectedUserForPopup.Rights?.URLs?.length || 0}} {{ 'AccountSettingsPage.PageAccess' | translate }}</span>
              <i class="material-icons arrow-icon">expand_more</i>
            </div>
            <div class="DropdownResults" *ngIf="showUrlAccessDropdown">
              <div class="DropdownItem" *ngFor="let url of URLs"
                   [class.selected]="isUrlSelected(url, selectedUserForPopup)"
                   (click)="toggleUrlAccess(url, selectedUserForPopup);">
                <div>
                  <span>{{url.Application?.Name}}</span>
                  <span class="DropdownItemSub">{{url.Path}}</span>
                </div>
                <i class="material-icons check-icon" *ngIf="isUrlSelected(url, selectedUserForPopup)">check</i>
              </div>
            </div>
          </div>
        </div>

        <!-- App Access Dropdown -->
        <div class="FormGroup">
          <label class="FormLabel">{{ 'AppAccess' | translate }}</label>
          <div class="CustomDropdown">
            <div class="DropdownTrigger" [class.open]="showAppAccessDropdown" (click)="showAppAccessDropdown = !showAppAccessDropdown;">
              <span>{{AppAccessApplications?.length || 0}} {{ 'AppAccess' | translate }}</span>
              <i class="material-icons arrow-icon">expand_more</i>
            </div>
            <div class="DropdownResults" *ngIf="showAppAccessDropdown">
              <div class="DropdownItem" *ngFor="let app of this.parent.Applications"
                   [class.selected]="isAppAccessSelected(app)"
                   (click)="toggleAppAccessCustom(app);">
                <span>{{app.Name}}</span>
                <i class="material-icons check-icon" *ngIf="isAppAccessSelected(app)">check</i>
              </div>
            </div>
          </div>
        </div>

        <!-- User Info -->
        <p class="SectionLabel">{{ 'AccountSettingsPage.UserID' | translate }}</p>
        <div class="InfoRow">
          <span class="InfoRowLabel">{{ 'AccountSettingsPage.UserID' | translate }}</span>
          <span class="InfoRowValue">{{selectedUserForPopup.Id}}</span>
        </div>
        <div class="InfoRow">
          <span class="InfoRowLabel">{{ 'AccountSettingsPage.SecretToken' | translate }}</span>
          <span class="InfoRowValue">{{selectedUserForPopup.Token}}</span>
        </div>
        <div class="InfoRow">
          <span class="InfoRowLabel">{{ 'AccountSettingsPage.Registered' | translate }}</span>
          <span class="InfoRowValue">{{selectedUserForPopup.EventRegisterUI}}</span>
        </div>

        <!-- B2B Partner -->
        <div class="B2BRow" *ngIf="this.UserHasB2BAccess == true;">
          <span class="B2BRowLabel">{{'B2BConnectedPartner' | translate }}:</span>
          <button class="BtnPrimary BtnSmall BtnAttention" (click)="OpenPartnerSelectContainer();" *ngIf="B2BPartner == null;">
            <i class="material-icons" style="font-size:14px;">account_circle</i>
            {{'ChoosePartner' | translate}}
          </button>
          <button class="BtnPrimary BtnSmall" (click)="OpenPartnerSelectContainer();" *ngIf="B2BPartner?.ID?.length > 0;">
            <i class="material-icons" style="font-size:14px;">account_circle</i>
            {{B2BPartner?.Name}}
          </button>
        </div>

        <!-- B2B Agent -->
        <div class="B2BRow" *ngIf="this.UserHasB2BAccess == true;">
          <span class="B2BRowLabel">{{'B2BConnectedAgent' | translate }}:</span>
          <button class="BtnPrimary BtnSmall BtnAttention" (click)="OpenAgentSelectContainer();" *ngIf="B2BAgent == null;">
            <i class="material-icons" style="font-size:14px;">account_circle</i>
            {{'ChooseAgent' | translate}}
          </button>
          <button class="BtnPrimary BtnSmall" (click)="OpenAgentSelectContainer();" *ngIf="B2BAgent?.Name?.length > 0;">
            <i class="material-icons" style="font-size:14px;">account_circle</i>
            {{B2BAgent?.Name}}
          </button>
          <button class="B2BAgentRemoveBtn" *ngIf="B2BAgent?.Name?.length > 0;" (click)="PrepareB2BAgentDeallocation();">
            <i class="material-icons">close</i>
          </button>
        </div>

        <!-- Toggles -->
        <div class="ToggleRow" *ngIf="B2BPartner?.ID?.length > 0 && B2BPartner?.B2BSettings;">
          <span class="ToggleLabel">{{'CanDownloadPriceLists' | translate}}</span>
          <label class="ios-switch">
            <input type="checkbox" [(ngModel)]="B2BPartner.B2BSettings.CanDownloadPriceLists" (ngModelChange)="AddUpdatePartnerB2BSettings(B2BPartner.B2BSettings.CanDownloadPriceLists);">
            <span class="slider"></span>
          </label>
        </div>

        <div class="ToggleRow">
          <span class="ToggleLabel">{{'DisabledUser' | translate}}</span>
          <label class="ios-switch">
            <input type="checkbox" [(ngModel)]="selectedUserForPopup.Disabled" (ngModelChange)="EnableDisableUser(selectedUserForPopup.Id, selectedUserForPopup.Disabled);">
            <span class="slider"></span>
          </label>
        </div>

        <div class="ToggleRow" *ngIf="selectedUserForPopup.B2BSettings != null;">
          <span class="ToggleLabel">{{'HasB2BSearchPriceAPIAccess' | translate}}</span>
          <label class="ios-switch">
            <input type="checkbox" [(ngModel)]="selectedUserForPopup.B2BSettings.B2BSearchPriceAPIAccess" (ngModelChange)="UpdateB2BSearchPriceAPIAccess(selectedUserForPopup, selectedUserForPopup.B2BSettings.B2BSearchPriceAPIAccess);">
            <span class="slider"></span>
          </label>
        </div>

        <!-- Errors -->
        <div class="UserErrorRow" *ngFor="let error of selectedUserForPopup.Rights?.AccessErrors">
          <i class="material-icons">warning_amber</i>
          <span>{{error}}</span>
        </div>

        <!-- Assigned Companies -->
        <p class="SectionLabel" *ngIf="selectedUserForPopup.Rights?.AssignedCompanies?.length > 0">{{ 'AccessLevelOnThisCompany' | translate }}</p>
        <div class="CompaniesGrid" *ngIf="!loadingUser">
          <div class="CompanyCard" *ngFor="let c of selectedUserForPopup.Rights?.AssignedCompanies; let index = index">
            <p class="CompanyCardTitle">{{c.Name}}</p>
            <p class="CompanyCardSub">{{c.VATNumber}}</p>
            <p class="CompanyCardSub">{{c.COCRegisterNr}}</p>
            <p class="CompanyCardSub" *ngIf="c.RequestedAccess != null;">{{ 'AccountSettingsPage.AccessRequestedOn' | translate }} {{c.RequestedAccess.EventUI}}</p>
            <div class="CompanyCardAccess" *ngIf="c.MainRole?.ID > 0;">
              <i class="material-icons">check_circle</i>
            </div>

            <div class="CompanyCardControls">
              <!-- Company Role Dropdown -->
              <div class="CustomDropdown">
                <div class="DropdownTrigger" [class.open]="companyRoleDropdowns[c.ID]" (click)="companyRoleDropdowns[c.ID] = !companyRoleDropdowns[c.ID];">
                  <span>{{c.MainRole?.Meaning || ('AccessLevelOnThisCompany' | translate)}}</span>
                  <i class="material-icons arrow-icon">expand_more</i>
                </div>
                <div class="DropdownResults" *ngIf="companyRoleDropdowns[c.ID]">
                  <div class="DropdownItem" *ngFor="let role of this.parent.masterData.Roles"
                       [class.selected]="c.MainRole?.ID === role.ID"
                       (click)="selectCompanyRole(role, c, selectedUserForPopup);">
                    <span>{{role.Meaning}}</span>
                    <i class="material-icons check-icon" *ngIf="c.MainRole?.ID === role.ID">check</i>
                  </div>
                </div>
              </div>

              <!-- Company Department Dropdown -->
              <div class="CustomDropdown">
                <div class="DropdownTrigger" [class.open]="companyDeptDropdowns[c.ID]" (click)="companyDeptDropdowns[c.ID] = !companyDeptDropdowns[c.ID];">
                  <span>{{c.Department?.Name || ('FunctionInsideCompany' | translate)}}</span>
                  <i class="material-icons arrow-icon">expand_more</i>
                </div>
                <div class="DropdownResults" *ngIf="companyDeptDropdowns[c.ID]">
                  <div class="DropdownItem" *ngFor="let f of this.parent.masterData.Departments"
                       [class.selected]="c.Department?.ID === f.ID"
                       (click)="selectCompanyDept(f, c, selectedUserForPopup);">
                    <span>{{f.Name}}</span>
                    <i class="material-icons check-icon" *ngIf="c.Department?.ID === f.ID">check</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Overlay for modals (outside UsersMainContent to ensure proper viewport centering) -->
<div class="overlay" *ngIf="ShowB2BAgentDeallocation || ShowGrantAllURLsAccess || PartnerSelectContainer || AgentSelectContainer;" (click)="ShowB2BAgentDeallocation=false; ShowGrantAllURLsAccess=false; ClosePartnerSelectContainer(); AgentSelectContainer=false;"></div>

<!-- Partner Select Modal -->
<div class="ModalDialog" *ngIf="this.PartnerSelectContainer == true;">
  <div class="ModalHeader">
    <span class="ModalTitle">{{'B2BConnectedPartner' | translate}}</span>
    <button class="ModalCloseBtn" (click)="ClosePartnerSelectContainer();">
      <i class="material-icons">close</i>
    </button>
  </div>
  <div class="ModalBody">
    <div style="position: relative;">
      <input class="PartnerSearchInput" type="text"
             [placeholder]="'ChoosePartner' | translate"
             [(ngModel)]="this.Filter.SearchTerm"
             (ngModelChange)="this.partnerSearchTermUpdate.next($event)" autocomplete="off">
      <i class="material-icons" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);font-size:16px;color:#8e8e93;cursor:pointer;"
         *ngIf="this.SelectedPartnerInModal?.Name?.length > 0;" (click)="ClearSelectedPartner(); this.SelectedPartnerInModal = null;">close</i>
    </div>
    <div class="PartnerResults" *ngIf="Partners?.length > 0">
      <div class="PartnerResultItem" *ngFor="let p of Partners"
           [class.selected]="SelectedPartnerInModal?.ID === p.ID"
           (click)="SelectPartnerInModal(p);">
        <span>{{p.Name}}</span>
        <i class="material-icons check-icon" *ngIf="SelectedPartnerInModal?.ID === p.ID">check</i>
      </div>
    </div>
  </div>
  <div class="ModalFooter">
    <button class="BtnPrimary" [disabled]="!SelectedPartnerInModal" (click)="ConfirmSelectedPartner();">{{'ChoosePartner' | translate}}</button>
  </div>
</div>

<!-- Agent Select Modal -->
<div class="ModalDialog" *ngIf="this.AgentSelectContainer == true;">
  <div class="ModalHeader">
    <span class="ModalTitle">{{'B2BConnectedAgent' | translate}}</span>
    <button class="ModalCloseBtn" (click)="AgentSelectContainer = false;">
      <i class="material-icons">close</i>
    </button>
  </div>
  <div class="ModalBody">
    <div class="FormGroup">
      <label class="FormLabel">{{ 'B2BConnectedAgent' | translate }}</label>
      <div class="CustomDropdown">
        <div class="DropdownTrigger" [class.open]="showAgentDropdownInDialog" (click)="showAgentDropdownInDialog = !showAgentDropdownInDialog;">
          <span>{{B2BAgent?.Name || ('ChooseAgent' | translate)}}</span>
          <i class="material-icons arrow-icon">expand_more</i>
        </div>
        <div class="DropdownResults" *ngIf="showAgentDropdownInDialog">
          <div class="DropdownItem" *ngFor="let agent of this.Agents"
               [class.selected]="B2BAgent?.ID === agent.ID"
               (click)="selectAgentInDialog(agent);">
            <span>{{agent.Name}}</span>
            <i class="material-icons check-icon" *ngIf="B2BAgent?.ID === agent.ID">check</i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ModalFooter">
    <button class="BtnPrimary" (click)="AddUpdateB2BUserAgentConnection();">{{'ChooseAgent' | translate}}</button>
  </div>
</div>

<!-- Grant All URLs Access Modal -->
<div class="ModalDialog" *ngIf="ShowGrantAllURLsAccess">
  <div class="ModalHeader">
    <span class="ModalTitle">
      <span *ngIf="AppAccess?.Access == true;">{{'GrantAllURLsAccess' | translate}}</span>
      <span *ngIf="AppAccess?.Access != true;">{{'UnGrantAllURLsAccess' | translate}}</span>
    </span>
    <button class="ModalCloseBtn" (click)="ShowGrantAllURLsAccess = false;">
      <i class="material-icons">close</i>
    </button>
  </div>
  <div class="ModalBody">
    <p class="ModalBodyText" *ngIf="AppAccess?.Access == true;">{{'GrantAllURLsAccessDescription' | translate}}</p>
    <p class="ModalBodyText" *ngIf="AppAccess?.Access != true;">{{'UnGrantAllURLsAccessDescription' | translate}}</p>
  </div>
  <div class="ModalFooter">
    <button class="BtnSecondary" [disabled]="this.parent.loading" (click)="ShowGrantAllURLsAccess = false;">
      {{ 'CancelButton' | translate }}
    </button>
    <button class="BtnPrimary" [disabled]="this.parent.loading" *ngIf="AppAccess?.Access == true;" (click)="GrantUserAppUrlsAccess(this.AppAccess);">
      {{ 'GrantAllURLsAccessButton' | translate }}
    </button>
    <button class="BtnPrimary" [disabled]="this.parent.loading" *ngIf="AppAccess?.Access != true;" (click)="GrantUserAppUrlsAccess(this.AppAccess);">
      {{ 'UnGrantAllURLsAccessButton' | translate }}
    </button>
  </div>
</div>

<!-- B2B Agent Deallocation Confirm Modal -->
<div class="ModalDialog" *ngIf="ShowB2BAgentDeallocation">
  <div class="ModalHeader">
    <span class="ModalTitle">{{ 'Configuration.DeleteQuestion' | translate }}</span>
    <button class="ModalCloseBtn" (click)="ShowB2BAgentDeallocation = false;">
      <i class="material-icons">close</i>
    </button>
  </div>
  <div class="ModalBody">
    <p class="ModalBodyText">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
  </div>
  <div class="ModalFooter">
    <button class="BtnSecondary" [disabled]="this.parent.loading" (click)="ShowB2BAgentDeallocation = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button class="BtnDanger" [disabled]="this.parent.loading" (click)="ShowB2BAgentDeallocation = false; DeallocateB2BUserAgentConnection();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
  </div>
</div>
